import { VerificationResponseIdToken } from "@iddataweb/idw-common-ui/types";

export enum CommonActionTypes {
    SET_CUSTOM_CSS_LOADED = "SET_CUSTOM_CSS_LOADED",
    SET_CUSTOM_FOOTER_HTML = "SET_CUSTOM_FOOTER_HTML",
    SET_CUSTOM_HEADER_HTML = "SET_CUSTOM_HEADER_HTML",
    SET_REDIRECT_URL = "SET_REDIRECT_URL",
    SET_VERIFICATION_MESSAGE = "SET_VERIFICATION_MESSAGE",
    SUBMIT_VERIFICATION_DATA = "SUBMIT_VERIFICATION_DATA",
    SUBMIT_VERIFICATION_DATA_FAILED = "SUBMIT_VERIFICATION_DATA_FAILED",
    SET_SHOULD_REDIRECT = "SET_SHOULD_REDIRECT",
    SET_SHOULD_UPDATE_SUBMIT_BUTTON = "SET_SHOULD_UPDATE_SUBMIT_BUTTON",
    SET_LANDING_PAGE_DATA = "SET_LANDING_PAGE_DATA"
}

type SetCustomCssLoadedAction = {
    type: CommonActionTypes.SET_CUSTOM_CSS_LOADED,
    payload: { isCustomCssLoaded: boolean; };
};

export const setCustomCssLoaded = (isCustomCssLoaded: boolean): SetCustomCssLoadedAction => ({
    type: CommonActionTypes.SET_CUSTOM_CSS_LOADED,
    payload: {
        isCustomCssLoaded
    }
});

type SetCustomFooterHtmlAction = {
    type: CommonActionTypes.SET_CUSTOM_FOOTER_HTML,
    payload: { html: string };
};

export const setCustomFooterHtml = (html: string): SetCustomFooterHtmlAction => ({
    type: CommonActionTypes.SET_CUSTOM_FOOTER_HTML,
    payload: {
        html
    }
});

type SetCustomHeaderHtmlAction = {
    type: CommonActionTypes.SET_CUSTOM_HEADER_HTML,
    payload: { html: string };
};

export const setCustomHeaderHtml = (html: string): SetCustomHeaderHtmlAction => ({
    type: CommonActionTypes.SET_CUSTOM_HEADER_HTML,
    payload: {
        html
    }
});

type SetRedirectUrlAction = {
    type: CommonActionTypes.SET_REDIRECT_URL,
    payload: { redirectUrl: string };
};

export const setRedirectUrl = (redirectUrl: string): SetRedirectUrlAction => ({
    type: CommonActionTypes.SET_REDIRECT_URL,
    payload: {
        redirectUrl
    }
});

type SetVerificationMessageAction = {
    type: CommonActionTypes.SET_VERIFICATION_MESSAGE;
    payload: { message: string };
};

export const setVerificationMessage = (message: string): SetVerificationMessageAction => ({
    type: CommonActionTypes.SET_VERIFICATION_MESSAGE,
    payload: { message }
});

type SubmitVerificationDataAction = {
    type: CommonActionTypes.SUBMIT_VERIFICATION_DATA
};

export const submitVerificationData = (): SubmitVerificationDataAction => ({
    type: CommonActionTypes.SUBMIT_VERIFICATION_DATA
});

type SubmitVerificationDataFailedAction = {
    type: CommonActionTypes.SUBMIT_VERIFICATION_DATA_FAILED,
    payload: { message: string };
};

export const submitVerificationDataFailed = (message: string): SubmitVerificationDataFailedAction => ({
    type: CommonActionTypes.SUBMIT_VERIFICATION_DATA_FAILED,
    payload: {
        message
    }
});

type SetShouldRedirectAction = {
    type: CommonActionTypes.SET_SHOULD_REDIRECT,
    payload: { shouldRedirect: boolean };
};

export const setShouldRedirect = (shouldRedirect: boolean): SetShouldRedirectAction => ({
    type: CommonActionTypes.SET_SHOULD_REDIRECT,
    payload: { shouldRedirect }
});

type SetShouldUpdateSubmitButtonAction = {
    type: CommonActionTypes.SET_SHOULD_UPDATE_SUBMIT_BUTTON,
    payload: { shouldUpdate: boolean }
};

export const setShouldUpdateSubmitButton = (shouldUpdate: boolean): SetShouldUpdateSubmitButtonAction => ({
    type: CommonActionTypes.SET_SHOULD_UPDATE_SUBMIT_BUTTON,
    payload: { shouldUpdate }
});

type SetLandingPageDataAction = {
    type: CommonActionTypes.SET_LANDING_PAGE_DATA,
    payload: { landingPageData: VerificationResponseIdToken; }
};

export const setLandingPageData = (landingPageData: VerificationResponseIdToken): SetLandingPageDataAction => ({
    type: CommonActionTypes.SET_LANDING_PAGE_DATA,
    payload: { landingPageData }
});

export type CommonActions =
    SetCustomCssLoadedAction |
    SetCustomFooterHtmlAction |
    SetCustomHeaderHtmlAction |
    SetRedirectUrlAction |
    SetVerificationMessageAction |
    SubmitVerificationDataAction |
    SubmitVerificationDataFailedAction |
    SetShouldRedirectAction |
    SetShouldUpdateSubmitButtonAction |
    SetLandingPageDataAction